(function () {
  'use strict';

  var pageClass = 'converter-collection-page';

  function hubElement() {
    return document.querySelector('[data-converter-hub]');
  }

  function collectionHandle() {
    var hub = hubElement();
    return hub ? hub.getAttribute('data-collection-handle') || '' : '';
  }

  function emitInteraction(name, label, properties) {
    var detail = Object.assign({
      interaction: name,
      label: label || '',
      collection_handle: collectionHandle()
    }, properties || {});

    var hub = hubElement();
    var analyticsEventName = hub ? hub.getAttribute('data-analytics-event') || 'converter_collection_interaction' : 'converter_collection_interaction';
    var themeEventName = hub ? hub.getAttribute('data-theme-event') || 'theme:converter-collection-interaction' : 'theme:converter-collection-interaction';

    document.dispatchEvent(new CustomEvent(themeEventName, {
      detail: detail
    }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: analyticsEventName }, detail));
    }
  }

  function initFaqs(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-converter-faq]'), function (details) {
      if (details.dataset.converterInitialized === 'true') return;
      details.dataset.converterInitialized = 'true';
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var summary = details.querySelector('summary');
        emitInteraction('faq_open', summary ? summary.textContent.trim() : 'FAQ');
      });
    });
  }

  function initPage(scope) {
    if (!document.documentElement.classList.contains(pageClass)) return;
    initFaqs(scope);
  }

  document.addEventListener('click', function (event) {
    if (!document.documentElement.classList.contains(pageClass)) return;
    var tracked = event.target.closest('[data-converter-event]');
    if (!tracked) return;
    emitInteraction(
      tracked.dataset.converterEvent,
      tracked.dataset.converterLabel || tracked.textContent.trim(),
      { destination: tracked.getAttribute('href') || '' }
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPage(document); });
  } else {
    initPage(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-converter-hub]')) {
      document.documentElement.classList.add(pageClass);
    }
    initPage(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      if (!document.querySelector('[data-converter-hub]')) {
        document.documentElement.classList.remove(pageClass);
      }
    }, 0);
  });
}());
